function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0391 0C17.9262 0 0 17.9262 0 40.0391C0 62.152 17.9262 80.0781 40.0391 80.0781C62.152 80.0781 80.0781 62.152 80.0781 40.0391C80.0781 17.9262 62.152 0 40.0391 0ZM40.0391 52.7344C33.0389 52.7344 27.3438 47.0395 27.3438 40.0391C27.3438 33.0387 33.0389 27.3438 40.0391 27.3438C47.0393 27.3438 52.7344 33.0387 52.7344 40.0391C52.7344 47.0395 47.0393 52.7344 40.0391 52.7344Z",
  fill: "#1ED760"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M52.7344 40.0391C52.7344 47.0395 47.0393 52.7344 40.0391 52.7344V80.0781C62.152 80.0781 80.0781 62.152 80.0781 40.0391C80.0781 17.9262 62.152 0 40.0391 0V27.3438C47.0393 27.3438 52.7344 33.0387 52.7344 40.0391Z",
  fill: "#1DB954"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0391 19.5312C28.7311 19.5312 19.5312 28.7311 19.5312 40.0391C19.5312 51.3471 28.7311 60.5469 40.0391 60.5469C51.3471 60.5469 60.5469 51.3471 60.5469 40.0391C60.5469 28.7311 51.3471 19.5312 40.0391 19.5312ZM40.0391 48.8281C35.1928 48.8281 31.25 44.8854 31.25 40.0391C31.25 35.1928 35.1928 31.25 40.0391 31.25C44.8854 31.25 48.8281 35.1928 48.8281 40.0391C48.8281 44.8854 44.8854 48.8281 40.0391 48.8281Z",
  fill: "#F9F9F9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0391 31.25C44.8854 31.25 48.8281 35.1928 48.8281 40.0391C48.8281 44.8854 44.8854 48.8281 40.0391 48.8281V60.5469C51.3471 60.5469 60.5469 51.3471 60.5469 40.0391C60.5469 28.7311 51.3471 19.5312 40.0391 19.5312V31.25Z",
  fill: "#D5D3EA"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M98.8732 45.933C98.1621 45.3777 97.2348 45.181 96.3598 45.4L65.1098 53.2125C63.8057 53.5385 62.8906 54.7103 62.8906 56.0547V84.6223C62.2662 84.4609 61.6117 84.375 60.9375 84.375C56.6297 84.375 53.125 87.8797 53.125 92.1875C53.125 96.4953 56.6297 100 60.9375 100C65.2453 100 68.75 96.4953 68.75 92.1875V68.1076L94.1406 61.76V80.716C93.5162 80.5547 92.8617 80.4688 92.1875 80.4688C87.8797 80.4688 84.375 83.9734 84.375 88.2813C84.375 92.5891 87.8797 96.0938 92.1875 96.0938C96.4953 96.0938 100 92.5891 100 88.2813V48.2422C100 47.34 99.5844 46.4883 98.8732 45.933Z",
  fill: "#DBDBDB"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M98.8732 45.933C98.1621 45.3777 97.2348 45.181 96.3598 45.4L80.7348 49.3062V65.1113L94.1406 61.7599V80.716C93.5162 80.5547 92.8617 80.4687 92.1875 80.4687C87.8797 80.4687 84.375 83.9734 84.375 88.2812C84.375 92.5891 87.8797 96.0937 92.1875 96.0937C96.4953 96.0937 100 92.5891 100 88.2812V48.2422C100 47.34 99.5844 46.4883 98.8732 45.933Z",
  fill: "white"
});

function SvgDisc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisc);
export default __webpack_public_path__ + "static/media/disc.6ec3d269.svg";
export { ForwardRef as ReactComponent };